export const COIN = {
  name: "UFO COIN",
  symbol: "$UFO",
  taglineTop: "THE SIGNAL IS REAL",
  taglineBottom: "THE FUTURE IS OURS",
  tagline: "O SINAL É REAL. O FUTURO É NOSSO.",
  contract: "EM BREVE / PUMP.FUN",
  supply: "1,000,000,000",
  network: "Solana",
  launchPlatform: "pump.fun",
  logo: "https://customer-assets.emergentagent.com/job_ufo-crypto-coin/artifacts/5jn2sade_ufocoin.png",
  socials: {
    telegram: "https://t.me/UFOcoinOFC",
    twitter: "https://x.com/UFOCoinSOL",
    pumpfun: "https://pump.fun",
    dex: "https://dexscreener.com/",
  },
};

export const IMAGES = {
  heroBg: "https://images.unsplash.com/photo-1464802686167-b939a6910659?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxkZWVwJTIwc3BhY2UlMjBnYWxheHl8ZW58MHx8fHwxNzgzODU1MjUwfDA&ixlib=rb-4.1.0&q=85",
  alien: "https://images.unsplash.com/photo-1763493489606-cf820b9ab3d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxhbGllbiUyMG5lb24lMjBncmVlbnxlbnwwfHx8fDE3ODM4NTUyNTB8MA&ixlib=rb-4.1.0&q=85",
  sectionBg: "https://images.unsplash.com/photo-1465101162946-4377e57745c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxkZWVwJTIwc3BhY2UlMjBnYWxheHl8ZW58MHx8fHwxNzgzODU1MjUwfDA&ixlib=rb-4.1.0&q=85",
  abstract: "https://images.unsplash.com/photo-1667202374066-03b435d61db0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHwzZCUyMG5lb24lMjBzcGhlcmUlMjBhYnN0cmFjdHxlbnwwfHx8fDE3ODM4NTUyNjh8MA&ixlib=rb-4.1.0&q=85",
};
